import { render, staticRenderFns } from "./AreaExample.vue?vue&type=template&id=538a15e0&"
import script from "./AreaExample.vue?vue&type=script&lang=js&"
export * from "./AreaExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports